import * as types from '../actiontypes';
export function setIsModalOpen(isModalOpen) {
	return {
		type: types.SET_IS_MODAL_OPEN,
		isModalOpen
	};
}
